(function () {
  try {
    var path = (location.pathname || '').toLowerCase();
    var text = null;
    if (path.indexOf('/products/neo-pro-titanium') !== -1) {
      text = 'Ships from Oct 25, 2026';
    } else if (path.indexOf('/products/neo-pro') !== -1) {
      text = 'Ships by Sep 25, 2026 (FIFO)';
    }
    if (!text) return;
    function rewrite(root) {
      var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var v = node.nodeValue || '';
        if (/as soon as possible/i.test(v) || (/Shipping:\s*ASAP/i.test(v))) {
          node.nodeValue = v.replace(/Shipping:\s*As soon as possible/ig, 'Shipping: ' + text)
            .replace(/As soon as possible/ig, text)
            .replace(/Shipping:\s*ASAP/ig, 'Shipping: ' + text)
            .replace(/\bASAP\b/g, text);
        }
      }
    }
    rewrite(document.body);
    var obs = new MutationObserver(function () { rewrite(document.body); });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
})();
